import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useImageEmptyViewStyle = makeStyles({
  emptyView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.gap('8px'),
  },
  emptyIcon: {
    width: '256px',
    height: '256px',
  },
  mainText: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    textAlign: 'center',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: tokens.neutralForegroundRest,
    lineHeight: '22px',
    fontWeight: 400,
  },
});

